import { sendGAEvent } from '../ga/ga.helpers';
import { GAEventName } from '../ga/ga.types';

export const openBookDemo = (userId: number) => {
  sendGAEvent(GAEventName.Demo, { userId, value: 10 });
  const url = 'https://maptivedemo.youcanbook.me/?SOURCE=app_home_link';
  window.open(url, 'bookADemo', 'width=940,height=687,scrollbars=yes');
};
